/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({ name: 'homeSearch' })

export class HomeSearchFilterPipe implements PipeTransform {

    transform(cards:any, value: any) {
        if (cards) {
            return cards.filter(function(item: any){
                return item.name.toLowerCase().match(value.toLowerCase()) && item.name.toLowerCase().match(value.toLowerCase()).length>0;
            });
        }
    }
}

@Pipe({ name: 'homeSearchCount' })

export class HomeSearchFilterPipeCount implements PipeTransform {

    transform(cards:any, value: any) {
        let sItem:any=[{}], cardItems=[];
        if (cards) {
            cardItems = cards.filter(function(item: any){
                return item.name.toLowerCase().match(value.toLowerCase()) && item.name.toLowerCase().match(value.toLowerCase()).length>0;
            });
            if(cardItems.length<=0){
                sItem[0].count = 0;
            }else{
                sItem[0].count = cards.length;
            }
        }else{
            sItem[0].count =0;
        }
        return sItem;
    }

}